import { executeAction } from './global.actions'
import Service from 'src/services/clientOpt.services'

export const actions = {
  detail: 'CLIENT_OPT_DETAIL',
}

export const getClientDetail = (clientId: number) => dispatch => {
  const process = async () => ({
    payload: await Service.getDetail(clientId),
  })
  dispatch(executeAction(actions.detail, process))
}
